import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { viewStoriesHome } from '../../actions/userActions';
import StoriesBarNewView from '../../containers/Home/StoriesBarNew/StoriesBarNew'

const StoriesBarNew = ({stories,
    refShowStories,
    storyData,
    currenStoryView,
    setCurrenStoryView,
    currenSubStory,
    setIsShowStories,
    setCurrenSubStory}) => {
    const { isLoadingStoriesHomeList, storiesHomeList } = useSelector((state) => state.userInfo);
    
    useEffect(() => {
        dispatch(viewStoriesHome())
    }, [])
    
    const dispatch = useDispatch()
    return (
        <StoriesBarNewView 
        setIsShowStories={setIsShowStories}
        storyData ={storyData}
        currenStoryView ={currenStoryView}
        currenSubStory = {currenSubStory}
        setCurrenSubStory ={setCurrenSubStory}
         />
    )
}

export default StoriesBarNew